<template>
  <div class="flex flex-col mb-2">
    <div class="flex w-full">
      <div class="flex flex-1">
        <div
          class="w-3/12 pr-2"
          v-if="mainFilterCondition && mainFilterCondition != 'all'"
        >
          <select
            v-model="binaryFilterCondition"
            class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
          >
            <option
              v-for="(cond, index) in binaryConditionData"
              :value="cond.value"
              :key="index"
            >
              {{ cond.name }}
            </option>
          </select>
        </div>
        <div :class="mainConditionClass">
          <select
            v-model="mainFilterCondition"
            class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
            @change="mainConditionChanged($event)"
          >
            <option
              v-for="(cond, index) in mainConditionData"
              :value="cond.value"
              :key="index"
              :data-name="cond.dataName"
              :disabled="cond.disabled"
            >
              {{ cond.name }}
            </option>
          </select>
        </div>
        <div
          :class="firstConditionClass"
          v-if="mainFilterCondition && mainFilterCondition != 'all'"
        >
          <select
            v-if="
              mainFilterCondition != 'hasip' &&
              mainFilterCondition != 'indaterange'
            "
            v-model="filterFirstConditionProx"
            class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
            @change="firstConditionChanged($event)"
          >
            <option value="">
              {{ this.$t('frontend_groovemail_segment_select') }}
            </option>
            <option
              v-for="data in this.firstConditionData"
              :value="data.id"
              :key="data.id"
              :data-name="data.name"
            >
              {{ data.name }}
            </option>
          </select>

          <text-input
            v-else-if="mainFilterCondition === 'hasip'"
            variant="base"
            v-model="filterFirstConditionProx"
            @input="firstConditionChanged($event)"
            :placeholder="this.$t('frontend_groovemail_leads_filter_enter_ip')"
          />

          <date-range-picker
            v-else-if="mainFilterCondition === 'indaterange'"
            class="w-full"
            ref="picker"
            v-model="filterFirstConditionProx"
            value="filterFirstConditionProx"
            @update="firstConditionChanged($event)"
            :opens="opens"
            :autoApply="autoApply"
            :max-date="maxDateForFilter"
            :startDate="customStartDate"
            :endDate="customEndDate"
            :ranges="customDateRanges"
          >
            <div slot="input" slot-scope="picker">
              {{ picker.startDate | moment('MM/DD/YYYY') }} -
              {{ picker.endDate | moment('MM/DD/YYYY') }}
            </div>
          </date-range-picker>
        </div>
        <div
          :class="secondConditionClass"
          v-if="
            mainFilterCondition === 'hastag' ||
            mainFilterCondition === 'clickbroadcast'
          "
        >
          <select
            v-model="filterSecondConditionProx"
            class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
            @change="secondConditionChanged($event)"
          >
            <option value="">
              {{ this.$t('frontend_groovemail_segment_select') }}
            </option>
            <option
              v-for="data in this.secondConditionData"
              :value="data.id"
              :key="data.id"
              :data-name="
                mainFilterCondition === 'clickbroadcast' ? data.id : data.name
              "
            >
              {{
                mainFilterCondition === 'clickbroadcast'
                  ? data.linkName
                  : data.name
              }}
            </option>
          </select>
        </div>
      </div>
      <div>
        <gd-button
          class="h-10 w-10"
          :disabled="this.addbtndisabled"
          @click="!addbtndisabled ? createNewFilter() : null"
          variant="primary" size="icon"
        >
          <PlusIcon class="h-7 w-7" />
        </gd-button>
      </div>
    </div>

    <div class="flex mt-4 mb-2">
      <div class="w-full flex flex-wrap items-center">
        <div
          v-for="(option, index) in selectedFiltersMain"
          :key="option.id"
          class="flex items-center mb-2"
        >
          <div
            class="rounded-full h-12 w-12 flex items-center justify-center border border-primary mr-5 ml-5"
            v-if="index !== 0"
          >
            {{ option.operation === '=' ? $t('frontend_groovemail_segment_and') : $t('frontend_groovemail_segment_or') }}
          </div>
          
          <div
            class="flex rounded px-2 py-1 font-semibold text-primary-invert text-xs bg-primary"
          >
            <div>
              {{ $t(getFilterPrefixName(option)) }}
              <span class="font-bold">{{
                option.action === 'clickbroadcast'
                  ? option.linkName
                  : option.name
              }}</span>
            </div>

            <div class="ml-2 hover:text-grey-200">
              <div class="cursor-pointer" @click="deleteFilter(option)">
                <span class="fas fa-times"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';

export default {
  props: {
    mainCondition: {
      required: true,
    },
    binaryCondition: {
      required: true,
    },
    binaryConditionData: {
      required: true,
    },
    mainConditionData: {
      required: true,
    },
    addbtndisabled: {
      required: true,
    },
    filterFirstCondition: {
      required: true,
    },
    firstConditionData: {
      required: true,
    },
    filterSecondCondition: {
      required: true,
    },
    secondConditionData: {
      required: true,
    },
    selectedFilters: {
      required: true,
    },
  },
  data() {
    return {
      mainFilterCondition: this.mainCondition,
      binaryFilterCondition: this.binaryCondition,
      filterFirstConditionProx: this.filterFirstCondition,
      filterSecondConditionProx: this.filterSecondCondition,
      selectedFiltersMain: this.selectedFilters,
      customStartDate: moment(),
      customEndDate: moment(),
      maxDateForFilter: new Date(),
      opens: 'left',
      autoApply: true,
    };
  },
  components: {
    PlusIcon,
  },
  watch: {
    selectedFilters() {
      this.selectedFiltersMain = this.selectedFilters;
    },

    binaryFilterCondition() {
      this.$emit('updateBinaryCondition', this.binaryFilterCondition);
    },

    selectedFiltersMain() {
      this.$emit('updateSelectedFilters', this.selectedFiltersMain);
    },
  },

  methods: {
    mainConditionChanged(event) {
      this.$emit('updateMainCondition', this.mainFilterCondition);
      this.filterFirstConditionProx = '';
      this.filterSecondConditionProx = '';
      this.$emit('mainConditionChanged', event);
    },

    createNewFilter() {
      this.$emit('createNewFilter');
    },

    // reset filter values
    resetFilter() {
      this.mainFilterCondition = '';
      this.binaryFilterCondition = 'AND';
      this.filterFirstConditionProx = '';
      this.filterSecondConditionProx = '';
    },

    firstConditionChanged(event) {
      this.filterSecondConditionProx = '';
      const firstCondtionData = {
        condData: this.filterFirstConditionProx,
        event,
      };
      this.$emit('firstConditionChanged', firstCondtionData);
    },

    secondConditionChanged(event) {
      const secondCondtionData = {
        condData: this.filterSecondConditionProx,
        event,
      };
      this.$emit('secondConditionChanged', secondCondtionData);
    },

    deleteFilter(filterOption) {
      this.$emit('deleteFilter', filterOption);
    },

    getFilterPrefixName(filterOption) {
      if (filterOption.type === '' && filterOption.action === 'all') {
        return 'frontend_groovemail_segment_subscribe_everybody';
      }
      if (filterOption.type === 'tag' && filterOption.action === 'hastag') {
        return 'frontend_groovemail_segment_subscribe_hastag';
      }
      if (filterOption.type === 'tag' && filterOption.action === 'notag') {
        return 'frontend_groovemail_segment_subscribe_doesnot';
      }
      if (
        filterOption.type === 'list' &&
        filterOption.action === 'subscribedlist'
      ) {
        return 'frontend_groovemail_segment_subscribed_tolist';
      }
      if (
        filterOption.type === 'list' &&
        filterOption.action === 'notsubscribedlist'
      ) {
        return 'frontend_groovemail_segment_not_subscribed_to_list';
      }
      if (filterOption.type === 'form' && filterOption.action === 'hasform') {
        return 'frontend_groovemail_lead_listing_filters_has_form';
      }
      if (
        filterOption.type === 'segment' &&
        filterOption.action === 'subscribedsegment'
      ) {
        return 'frontend_groovemail_lead_listing_filters_subscribed_to_segment';
      }
      if (
        filterOption.type === 'sequence' &&
        filterOption.action === 'subscribedsequence'
      ) {
        return 'frontend_groovemail_subscribed_to_sequence_filter_option';
      }
      if (filterOption.type === 'ip' && filterOption.action === 'hasip') {
        return 'frontend_groovemail_leads_filter_has_ip_option';
      }
      if (
        filterOption.type === 'broadcastopen' &&
        filterOption.action === 'openbroadcast'
      ) {
        return 'frontend_groovemail_leads_filter_opened_a_broadcast_option';
      }
      if (
        filterOption.type === 'broadcastclick' &&
        filterOption.action === 'clickbroadcast'
      ) {
        return 'frontend_groovemail_leads_filter_clicked_a_link_option';
      }
      if (
        filterOption.type === 'daterange' &&
        filterOption.action === 'indaterange'
      ) {
        return 'frontend_groovemail_leads_filter_date_range_option';
      }
      if (filterOption.type === 'status' && filterOption.action === 'hasstatus') {
        return 'frontend_groovemail_leads_filter_status_option';
      }
      return null;
    },
  },
  
  computed: {
    mainConditionClass() {
      switch (this.mainCondition) {
        case 'subscribedlist':
        case 'hasform':
        case 'notsubscribedlist':
        case 'subscribedsequence':
        case 'hasip':
        case 'openbroadcast':
        case 'indaterange':
        case 'hasstatus':
          return 'w-5/12 pr-2';
          
        case 'hastag':
        case 'notag':
        case 'clickbroadcast':
          return 'w-3/12 pr-2';
        default:
          return 'flex-1 pr-2';
      }
    },

    firstConditionClass() {
      switch (this.mainCondition) {
        case 'subscribedlist':
        case 'hasform':
        case 'notsubscribedlist':
        case 'subscribedsegment':
        case 'subscribedsequence':
        case 'hasip':
        case 'openbroadcast':
        case 'indaterange':
        case 'hasstatus':
          return 'w-4/12 pr-2';

        case 'hastag':
        case 'notag':
        case 'clickbroadcast':
          return 'w-3/12 pr-2';

        default:
          return 'w-0';
      }
    },

    secondConditionClass() {
      switch (this.mainCondition) {
        case 'hastag':
        case 'notag':
        case 'clickbroadcast':
          return 'w-3/12 pr-2';

        default:
          return 'w-0';
      }
    },

    customDateRanges() {
      const customDateRanges = {};
      customDateRanges[this.$t('frontend_dashboard_calender_filter_today')] = [
        moment(),
        moment(),
      ];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_yesterday')
      ] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_7_days')
      ] = [moment().subtract(6, 'days'), moment()];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_30_days')
      ] = [moment().subtract(29, 'days'), moment()];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_this_week')
      ] = [moment().startOf('week'), moment().endOf('week')];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_week')
      ] = [
        moment().subtract(1, 'week').startOf('week'),
        moment().subtract(1, 'week').endOf('week'),
      ];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_this_month')
      ] = [moment().startOf('month'), moment().endOf('month')];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_month')
      ] = [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_this_year')
      ] = [moment().startOf('year'), moment().endOf('year')];
      customDateRanges[
        this.$t('frontend_dashboard_calender_filter_last_year')
      ] = [
        moment().subtract(1, 'year').startOf('year'),
        moment().subtract(1, 'year').endOf('year'),
      ];
      customDateRanges[
        `${this.$t('frontend_groovevideo_videos_date_picker_all_time')}`
      ] = [moment('19700101', 'YYYYMMDD'), moment()];
      return customDateRanges;
    },
  },
};
</script>

<style lang="scss">
.reportrange-text {
  height: 40px;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

button.disabled-btn {
  opacity: 0.5;
}
</style>
